/**
 * Platform display names and copy for the review-image social post confirmation modal.
 */
export function socialPostPlatformName(postingType) {
  if (!postingType) return ''
  const type = String(postingType).toLowerCase()
  if (type === 'gbp' || type === 'google') {
    return 'Google Business Profile'
  }
  return postingType.charAt(0).toUpperCase() + postingType.slice(1)
}

export function socialPostConfirmMessage(postingType) {
  const platform = socialPostPlatformName(postingType)
  if (!platform) return ''
  return `We will create an image from this review and post it to ${platform}.`
}

export const socialPostModalTitle = 'Post review image'
